import useMutation from "src/hooks/useMutation";

function useCustomerAddressUpdate(id) {
  return useMutation({
    path: `/api/v1/customers/customerId/addresses/addressId`,
    method: "PUT",
    mutateRelatedDataList: {
      mutatePath: `/api/v1/customers/${id}/addresses`,
      shouldRevalidate: true,
    },
  });
}

export default useCustomerAddressUpdate;
